module.exports = __webpack_public_path__ + "img/418.a15c29dd.jpg";